import { createSlice } from '@reduxjs/toolkit';
import { companyApi } from 'features/company/query';
import { CompanyState } from 'features/company/types';

const initialState: CompanyState = {
  companyList: null,
};

const companySlice = createSlice({
  name: 'company',
  initialState,
  reducers: {},
  extraReducers: builder => {
    const { getCompanyList } = companyApi.endpoints;

    builder.addMatcher(getCompanyList.matchFulfilled, (state, { payload }) => {
      state.companyList = payload ?? null;
    });
  },
});

export default companySlice.reducer;
